/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { BrowserService } from './browser.service';

@Injectable({
  providedIn: 'root',
})
export class XdaStringsService {
  public strings: Record<string, string>;
  public eulas: Record<string, string>;
  public qs: Record<string, string>;

  constructor(
    private http: HttpClient,
    private title: Title,
    private browserService: BrowserService,
  ) {}

  loadStrings() {
    return this.http
      .get('/api/home/strings')
      .toPromise()
      .then((data: any) => {
        this.strings = data;
        this.title.setTitle(`Xerox® ${this.strings['APPNAME']}`);
      });
  }

  getAGEulas() {
    if (this.eulas) {
      return new Promise((resolve) => {
        resolve(this.eulas);
      });
    }
    return this.http
      .get<string>('/api/home/eulas')
      .toPromise()
      .then((data) => {
        this.eulas = JSON.parse(data);
        return this.eulas;
      });
  }
}
